import type { HTMLAttributes } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';

const ScreenReaderOnlyWrapper = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

function ScreenReaderOnly(props: HTMLAttributes<HTMLSpanElement>) {
    const { className, children } = props;

    return <ScreenReaderOnlyWrapper className={className}>{children}</ScreenReaderOnlyWrapper>;
}

export default withErrorBoundary(ScreenReaderOnly, {
    fallback: null,
    onError(error, info) {
        console.error('Error in ScreenReaderOnly component', { error, info });
    }
});
